import React, { PureComponent, Fragment } from 'react'
import { Grid, Button } from '@material-ui/core'

import EmployeeInfo from './EmployeeInfo'
import EmployeeCredentials from './EmployeeCredentials'
import { getRoles, createNewEmployeeByInvite } from '../../actions/employee'
import { getShopList, getShopTerminals } from '../../actions/shop'
import { connect } from 'react-redux'
import ContainerWithTitle from '../../containers/HOC/ContainerWithTitle'
import { hasAccess } from '../../utils/api'
import { globalValidator } from '../../utils/validations/common'
import { openErrorMessage } from '../../actions/message'
import { Appcues } from '../../utils/constants'
import NoteList from '../../components/Notes/NoteList'
import { getVehicles } from '../../actions/company'

class InviteEmployeeForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      employee: {},
    }
  }

  componentDidMount() {
    let { session } = this.props.authReducer
    this.props.dispatch(getRoles())
    this.props.dispatch(getShopList())
    this.props.dispatch(getVehicles())
    this.props.dispatch(
      getShopTerminals(session && session.assignedShop && session.assignedShop.id),
    )
  }

  onChange = (key, value) => {
    const { roles = [] } = this.props.employeeReducer || {}
    const { shopsList = {} } = this.props.shopReducer || {}

    let updatedEmployee = {
      ...this.state.employee,
      [key]: value,
    }

    if (key === 'roleId') {
      const adminOrManagerEmployee =
        roles &&
        roles.find((role) => role.id === value && (role.name == 'Admin' || role.name == 'Manager'))
      updatedEmployee.canApplyCustomDiscount = !!adminOrManagerEmployee
      const isAdmin = roles && roles.find((role) => role.id === value && role.name == 'Admin')
      let shopsId = []
      if (isAdmin) {
        shopsList &&
          shopsList.values.length > 0 &&
          shopsList.values.map((shop) => {
            shopsId.push(shop.id)
          })

        updatedEmployee.shops = shopsId
      }
    }

    this.setState({
      employee: updatedEmployee,
      errors: {},
    })
  }

  onCancel = () => {
    this.props.history.push('/settings/manage/invitedemployees')
  }

  onSendInvite = () => {
    let { employee = {} } = this.state
    const { address = {}, ...rest } = employee

    const keys = [
      { name: 'firstName', title: 'First Name', validateKey: 'required' },
      { name: 'lastName', title: 'Last Name', validateKey: 'required' },
      { name: 'roleId', title: 'Role', validateKey: 'required' },
      { name: 'phoneNumber', title: 'Phone', validateKey: 'phone' },
      { name: 'email', title: 'Email', validateKey: 'email' },
    ]

    let valid = globalValidator(employee, keys)

    if (valid === true) {
      Appcues.track('Invite sent to employee')
      this.props
        .dispatch(
          createNewEmployeeByInvite({
            ...rest,
            address: address.address || '',
            state: address.state || '',
            city: address.city || '',
            zipcode: address.zipCode || '',
          }),
        )
        .then((res) => {
          this.props.history.push('/settings/manage/invitedemployees')
        })
    } else {
      return this.props.dispatch(openErrorMessage(valid))
    }
  }

  render() {
    const { roles = [] } = this.props.employeeReducer || {}
    const { shopsList = {} } = this.props.shopReducer || {}
    const { terminals, vehicles } = this.props.companyReducer || {}

    const { employee = {} } = this.state

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <h3>Invite Employee</h3>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} className="role_permissions">
            {hasAccess() ? (
              <div className="pull-right margin-bottom-small">
                <Fragment>
                  <Button className="primary-button margin" onClick={this.onSendInvite}>
                    Send Invite
                  </Button>
                  <Button className="danger-button margin" onClick={this.onCancel}>
                    Cancel
                  </Button>
                </Fragment>
              </div>
            ) : null}
          </Grid>
        </Grid>
        <EmployeeInfo
          data={employee}
          editMode={true}
          roles={roles}
          shops={(shopsList && shopsList.values) || []}
          onChange={this.onChange}
          errors={{}}
          isInvite={true}
          vehicles={vehicles && vehicles.values && vehicles.values.length > 0 && vehicles.values}
          terminals={terminals.values || []}
        />
        <EmployeeCredentials
          data={employee}
          editMode={true}
          dbRoles={roles}
          shops={(shopsList && shopsList.values) || []}
          onChange={this.onChange}
          terminals={terminals.values || []}
          errors={{}}
          isInvite={true}
        />

        <NoteList data={employee} editMode={true} onChange={this.onChange} />
      </div>
    )
  }
}

export default connect((state) => ({
  employeeReducer: state.employeeReducer,
  shopReducer: state.shopReducer,
  dispatch: state.dispatch,
  authReducer: state.authReducer,
  companyReducer: state.companyReducer,
}))(ContainerWithTitle(InviteEmployeeForm, 'Invite Employee'))



// WEBPACK FOOTER //
// ./src/components/Employees/InviteEmployeeForm.js